import React from 'react';

import { ShareTabOmView } from '@xingternal/share';

import { JobShareContext } from '@/contexts';
import { JobPostingVisibleJobFragment } from '@/graphql/generated';

type Props = {
  job: JobPostingVisibleJobFragment;
};

const withShare = (WrappedComponent: React.FC<Props>): React.FC<Props> => {
  const WithShareComponent: React.FC<Props> = (props) => {
    const { job } = props;

    return (
      <ShareTabOmView
        trigger={(triggerShare) => (
          <JobShareContext.Provider value={{ triggerShare }}>
            <WrappedComponent {...props} />
          </JobShareContext.Provider>
        )}
        url={job.url}
        propChannel="wbm/propTracking"
        entryPoint="jobs_share_xingstatus"
        interactionTargetUrn={job.globalId}
        verb="SHARE"
      />
    );
  };

  return WithShareComponent;
};

export default withShare;
